import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
  class: "mb-4 w-full border p-4 rounded flex flex-col shadow"
};
const _hoisted_2 = {
  class: "mb-2 grow"
};
const _hoisted_3 = {
  key: 0,
  class: "inline-block bg-green-50 text-green-700 rounded px-1 mr-1"
};
const _hoisted_4 = {
  class: "font-bold"
};
const _hoisted_5 = {
  class: "inline-block bg-amber-50 text-amber-700 rounded px-1 mr-2"
};
const _hoisted_6 = {
  class: "inline-block bg-amber-50 text-amber-700 rounded px-1"
};
const _hoisted_7 = {
  class: "flex justify-between items-center justify-center mt-2"
};
import { persistDataSource } from "@/modules/database/services/db";
import { db } from "@/modules/main-menu/services/db";
import RichDialog from "@/modules/vue/components/RichDialog.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'GameSlot',
  props: {
    gameSlot: null
  },
  emits: ['deleted'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const message = useMessage();
    const dialog = ref(null);
    const remove = async gameSlot => {
      await dialog.value?.confirm();
      await gameSlot.remove();
      await persistDataSource(db);
      message.success(translator.t('done'));
      // todo: this does not triggers events, i dont know why
      emit('deleted');
    };
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [__props.gameSlot.autoSave ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('auto')), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_4, _toDisplayString(__props.gameSlot.teamName), 1)]), _createElementVNode("div", null, _toDisplayString(_ctx.$t('last_updated_at', {
        date: _ctx.$date(__props.gameSlot.updatedAt, 'LT L')
      })), 1), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('current_season_x', {
        season: __props.gameSlot.seasonId
      })), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$date(__props.gameSlot.gameDateAt)), 1)])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_NButton, {
        type: "error",
        secondary: "",
        onClick: _cache[0] || (_cache[0] = $event => remove(__props.gameSlot))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('delete')), 1)]),
        _: 1
      }), _renderSlot(_ctx.$slots, "cta")]), _createVNode(RichDialog, {
        ref_key: "dialog",
        ref: dialog,
        "confirmation-only": _ctx.$t('sure_you_want_to_delete_it?')
      }, null, 8, ["confirmation-only"])]);
    };
  }
});